import React, { useState, useEffect } from 'react';
import Header from '../../components/ui/Header';
import TransactionFilters from './components/TransactionFilters';
import TransactionSummaryCards from './components/TransactionSummaryCards';
import TransactionTable from './components/TransactionTable';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';



const TransactionHistory = () => {
  const [user] = useState({
    id: 'user_001',
    name: 'Sarah Johnson',
    email: 'sarah.johnson@email.com',
    role: 'customer'
  });

  const [filteredTransactions, setFilteredTransactions] = useState([]);
  const [activeFilters, setActiveFilters] = useState({});

  // Mock transaction data
  const mockTransactions = [
    {
      id: 'TXN-2024-001234',
      reference: 'REF-MT-789456',
      recipient: {
        name: 'Maria Rodriguez',
        bank: 'Banco Santander Spain',
        iban: 'ES91 2100 0418 4502 0005 1332'
      },
      sendAmount: 1500.00,
      sendCurrency: 'USD',
      receiveAmount: 1387.50,
      receiveCurrency: 'EUR',
      exchangeRate: '1 USD = 0.925 EUR',
      fee: 12.50,
      status: 'completed',
      createdAt: '2024-11-15T10:30:00Z',
      completedAt: '2024-11-16T14:22:00Z',
      riskScore: 25,
      amlStatus: 'cleared',
      pepStatus: 'cleared',
      sourceOfFunds: 'Salary',
      purpose: 'Family Support',
      timeline: [
        {
          status: 'initiated',
          title: 'Transaction Initiated',
          description: 'Transfer request submitted successfully',
          completedAt: '2024-11-15T10:30:00Z',
          details: { user_id: 'user_001', ip_address: '192.168.1.1' }
        },
        {
          status: 'processing',
          title: 'Processing Payment',
          description: 'Validating payment details and recipient information',
          completedAt: '2024-11-15T10:32:00Z'
        },
        {
          status: 'compliance_review',
          title: 'Compliance Review',
          description: 'Automated compliance checks in progress',
          completedAt: '2024-11-15T10:35:00Z'
        },
        {
          status: 'aml_check',
          title: 'AML Screening',
          description: 'Anti-money laundering checks completed',
          completedAt: '2024-11-15T10:37:00Z',
          details: { aml_score: '25/100', status: 'cleared' }
        },
        {
          status: 'funds_reserved',
          title: 'Funds Reserved',
          description: 'Payment amount reserved from your account',
          completedAt: '2024-11-15T10:40:00Z'
        },
        {
          status: 'sent_to_bank',
          title: 'Sent to Bank',
          description: 'Transfer instruction sent to correspondent bank',
          completedAt: '2024-11-15T11:15:00Z'
        },
        {
          status: 'in_transit',
          title: 'In Transit',
          description: 'Funds are being processed by the receiving bank',
          completedAt: '2024-11-16T09:00:00Z'
        },
        {
          status: 'completed',
          title: 'Transfer Completed',
          description: 'Funds successfully delivered to recipient',
          completedAt: '2024-11-16T14:22:00Z'
        }
      ],
      auditTrail: [
        { action: 'Transaction created', timestamp: '2024-11-15T10:30:00Z', user: 'sarah.johnson@email.com' },
        { action: 'Compliance review passed', timestamp: '2024-11-15T10:35:00Z', user: 'system' },
        { action: 'Funds reserved', timestamp: '2024-11-15T10:40:00Z', user: 'system' },
        { action: 'Transfer completed', timestamp: '2024-11-16T14:22:00Z', user: 'system' }
      ]
    },
    {
      id: 'TXN-2024-001235',
      reference: 'REF-MT-789457',
      recipient: {
        name: 'James Wilson',
        bank: 'Barclays Bank UK',
        iban: 'GB29 NWBK 6016 1331 9268 19'
      },
      sendAmount: 2500.00,
      sendCurrency: 'USD',
      receiveAmount: 1975.00,
      receiveCurrency: 'GBP',
      exchangeRate: '1 USD = 0.79 GBP',
      fee: 15.00,
      status: 'compliance_review',
      createdAt: '2024-11-17T14:15:00Z',
      completedAt: null,
      riskScore: 65,
      amlStatus: 'pending',
      pepStatus: 'cleared',
      sourceOfFunds: 'Business Income',
      purpose: 'Business Payment',
      timeline: [
        {
          status: 'initiated',
          title: 'Transaction Initiated',
          description: 'Transfer request submitted successfully',
          completedAt: '2024-11-17T14:15:00Z'
        },
        {
          status: 'processing',
          title: 'Processing Payment',
          description: 'Validating payment details and recipient information',
          completedAt: '2024-11-17T14:17:00Z'
        },
        {
          status: 'compliance_review',
          title: 'Compliance Review',
          description: 'Manual compliance review required due to amount threshold',
          completedAt: null
        },
        {
          status: 'aml_check',
          title: 'AML Screening',
          description: 'Pending enhanced due diligence',
          completedAt: null
        }
      ],
      auditTrail: [
        { action: 'Transaction created', timestamp: '2024-11-17T14:15:00Z', user: 'sarah.johnson@email.com' },
        { action: 'Flagged for manual review', timestamp: '2024-11-17T14:17:00Z', user: 'system' }
      ]
    },
    {
      id: 'TXN-2024-001236',
      reference: 'REF-MT-789458',
      recipient: {
        name: 'Pierre Dubois',
        bank: 'BNP Paribas France',
        iban: 'FR14 2004 1010 0505 0001 3M02 606'
      },
      sendAmount: 800.00,
      sendCurrency: 'USD',
      receiveAmount: 740.00,
      receiveCurrency: 'EUR',
      exchangeRate: '1 USD = 0.925 EUR',
      fee: 8.50,
      status: 'failed',
      createdAt: '2024-11-16T09:45:00Z',
      completedAt: '2024-11-16T10:15:00Z',
      riskScore: 15,
      amlStatus: 'cleared',
      pepStatus: 'cleared',
      sourceOfFunds: 'Savings',
      purpose: 'Personal Transfer',
      timeline: [
        {
          status: 'initiated',
          title: 'Transaction Initiated',
          description: 'Transfer request submitted successfully',
          completedAt: '2024-11-16T09:45:00Z'
        },
        {
          status: 'processing',
          title: 'Processing Payment',
          description: 'Validating payment details and recipient information',
          completedAt: '2024-11-16T09:47:00Z'
        },
        {
          status: 'failed',
          title: 'Transaction Failed',
          description: 'Insufficient funds in source account',
          completedAt: '2024-11-16T10:15:00Z',
          details: { error_code: 'INSUFFICIENT_FUNDS', retry_allowed: true }
        }
      ],
      auditTrail: [
        { action: 'Transaction created', timestamp: '2024-11-16T09:45:00Z', user: 'sarah.johnson@email.com' },
        { action: 'Payment failed', timestamp: '2024-11-16T10:15:00Z', user: 'system' }
      ]
    },
    {
      id: 'TXN-2024-001237',
      reference: 'REF-MT-789459',
      recipient: {
        name: 'Anna Kowalski',
        bank: 'PKO Bank Polski',
        iban: 'PL61 1090 1014 0000 0712 1981 2874'
      },
      sendAmount: 1200.00,
      sendCurrency: 'USD',
      receiveAmount: 4680.00,
      receiveCurrency: 'PLN',
      exchangeRate: '1 USD = 3.90 PLN',
      fee: 10.00,
      status: 'in_transit',
      createdAt: '2024-11-18T08:20:00Z',
      completedAt: null,
      riskScore: 35,
      amlStatus: 'cleared',
      pepStatus: 'cleared',
      sourceOfFunds: 'Freelance Work',
      purpose: 'Family Support',
      timeline: [
        {
          status: 'initiated',
          title: 'Transaction Initiated',
          description: 'Transfer request submitted successfully',
          completedAt: '2024-11-18T08:20:00Z'
        },
        {
          status: 'processing',
          title: 'Processing Payment',
          description: 'Validating payment details and recipient information',
          completedAt: '2024-11-18T08:22:00Z'
        },
        {
          status: 'compliance_review',
          title: 'Compliance Review',
          description: 'Automated compliance checks completed',
          completedAt: '2024-11-18T08:25:00Z'
        },
        {
          status: 'aml_check',
          title: 'AML Screening',
          description: 'Anti-money laundering checks passed',
          completedAt: '2024-11-18T08:27:00Z'
        },
        {
          status: 'funds_reserved',
          title: 'Funds Reserved',
          description: 'Payment amount reserved from your account',
          completedAt: '2024-11-18T08:30:00Z'
        },
        {
          status: 'sent_to_bank',
          title: 'Sent to Bank',
          description: 'Transfer instruction sent to correspondent bank',
          completedAt: '2024-11-18T09:15:00Z'
        },
        {
          status: 'in_transit',
          title: 'In Transit',
          description: 'Funds are being processed by the receiving bank',
          completedAt: '2024-11-18T11:00:00Z'
        }
      ],
      auditTrail: [
        { action: 'Transaction created', timestamp: '2024-11-18T08:20:00Z', user: 'sarah.johnson@email.com' },
        { action: 'Compliance review passed', timestamp: '2024-11-18T08:25:00Z', user: 'system' },
        { action: 'Funds reserved', timestamp: '2024-11-18T08:30:00Z', user: 'system' }
      ]
    },
    {
      id: 'TXN-2024-001238',
      reference: 'REF-MT-789460',
      recipient: {
        name: 'Roberto Silva',
        bank: 'Banco do Brasil',
        iban: 'BR97 0036 0305 0000 1000 9795 493P1'
      },
      sendAmount: 3000.00,
      sendCurrency: 'USD',
      receiveAmount: 15450.00,
      receiveCurrency: 'BRL',
      exchangeRate: '1 USD = 5.15 BRL',
      fee: 20.00,
      status: 'pending',
      createdAt: '2024-11-18T11:30:00Z',
      completedAt: null,
      riskScore: 45,
      amlStatus: 'pending',
      pepStatus: 'pending',
      sourceOfFunds: 'Investment Returns',
      purpose: 'Property Purchase',
      timeline: [
        {
          status: 'initiated',
          title: 'Transaction Initiated',
          description: 'Transfer request submitted successfully',
          completedAt: '2024-11-18T11:30:00Z'
        },
        {
          status: 'processing',
          title: 'Processing Payment',
          description: 'Validating payment details and recipient information',
          completedAt: null
        }
      ],
      auditTrail: [
        { action: 'Transaction created', timestamp: '2024-11-18T11:30:00Z', user: 'sarah.johnson@email.com' }
      ]
    }
  ];

  // Mock summary data
  const summaryData = {
    totalVolume: '$12,450.00',
    volumeTrend: 15.2,
    successRate: 92.5,
    successTrend: 3.1,
    pendingReview: 2,
    totalTransactions: 47,
    transactionTrend: 8.7
  };

  useEffect(() => {
    setFilteredTransactions(mockTransactions);
  }, []);

  const handleFiltersChange = (filters) => {
    setActiveFilters(filters);
    
    let filtered = mockTransactions?.filter(transaction => {
      // Search filter
      if (filters?.search) {
        const searchTerm = filters?.search?.toLowerCase();
        const matchesSearch = 
          transaction?.id?.toLowerCase()?.includes(searchTerm) ||
          transaction?.recipient?.name?.toLowerCase()?.includes(searchTerm) ||
          transaction?.recipient?.bank?.toLowerCase()?.includes(searchTerm);
        if (!matchesSearch) return false;
      }

      // Status filter
      if (filters?.status && transaction?.status !== filters?.status) {
        return false;
      }

      // Currency filter
      if (filters?.currency && 
          transaction?.sendCurrency !== filters?.currency && 
          transaction?.receiveCurrency !== filters?.currency) {
        return false;
      }

      // Date range filter
      if (filters?.dateFrom) {
        const transactionDate = new Date(transaction.createdAt);
        const fromDate = new Date(filters.dateFrom);
        if (transactionDate < fromDate) return false;
      }

      if (filters?.dateTo) {
        const transactionDate = new Date(transaction.createdAt);
        const toDate = new Date(filters.dateTo);
        toDate?.setHours(23, 59, 59, 999); // End of day
        if (transactionDate > toDate) return false;
      }

      // Amount range filter
      if (filters?.amountMin && transaction?.sendAmount < parseFloat(filters?.amountMin)) {
        return false;
      }

      if (filters?.amountMax && transaction?.sendAmount > parseFloat(filters?.amountMax)) {
        return false;
      }

      return true;
    });

    setFilteredTransactions(filtered);
  };

  const handleClearFilters = () => {
    setActiveFilters({});
    setFilteredTransactions(mockTransactions);
  };

  const handleExport = () => {
    // Mock export functionality
    const csvContent = [
      ['Transaction ID', 'Recipient', 'Send Amount', 'Send Currency', 'Receive Amount', 'Receive Currency', 'Status', 'Date']?.join(','),
      ...filteredTransactions?.map(t => [
        t?.id,
        t?.recipient?.name,
        t?.sendAmount,
        t?.sendCurrency,
        t?.receiveAmount,
        t?.receiveCurrency,
        t?.status,
        new Date(t.createdAt)?.toLocaleDateString()
      ]?.join(','))
    ]?.join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL?.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `transactions_${new Date()?.toISOString()?.split('T')?.[0]}.csv`;
    document.body?.appendChild(a);
    a?.click();
    document.body?.removeChild(a);
    window.URL?.revokeObjectURL(url);
  };

  const handleLogout = () => {
    // Mock logout functionality
    console.log('User logged out');
  };

  return (
    <div className="min-h-screen bg-background">
      <Header user={user} onLogout={handleLogout} />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Page Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-foreground">Transaction History</h1>
          <p className="text-muted-foreground mt-2">
            Track and manage all your international money transfers with detailed status updates and compliance information.
          </p>
        </div>

        {/* Summary Cards */}
        <TransactionSummaryCards summaryData={summaryData} />

        {/* Filters */}
        <TransactionFilters 
          onFiltersChange={handleFiltersChange}
          onClearFilters={handleClearFilters}
        />

        {/* Results Summary */}
        <div className="mb-4">
          <p className="text-sm text-muted-foreground">
            Showing {filteredTransactions?.length} of {mockTransactions?.length} transactions
            {Object.keys(activeFilters)?.some(key => activeFilters?.[key]) && (
              <span className="ml-2 text-primary">
                (filtered)
              </span>
            )}
          </p>
        </div>

        {/* Transaction Table */}
        <TransactionTable 
          transactions={filteredTransactions}
          onExport={handleExport}
        />

        {/* Empty State */}
        {filteredTransactions?.length === 0 && (
          <div className="text-center py-12">
            <div className="w-16 h-16 mx-auto mb-4 bg-muted rounded-full flex items-center justify-center">
              <Icon name="Search" size={24} className="text-muted-foreground" />
            </div>
            <h3 className="text-lg font-medium text-foreground mb-2">No transactions found</h3>
            <p className="text-muted-foreground mb-4">
              Try adjusting your filters or search criteria to find the transactions you're looking for.
            </p>
            <Button variant="outline" onClick={handleClearFilters}>
              Clear All Filters
            </Button>
          </div>
        )}
      </main>
    </div>
  );
};

export default TransactionHistory;